<template>
  <div class="list row">
    <div class="col-md-12">
      <h5><font-awesome-icon icon="info-circle" /> Kindly select all paramenters/criteria and click on 'Search' button to view bonus report.</h5>
    </div>
    <div class="col-md-12 hgap"></div>
    
    <div class="col-md-12">
      <div class="input-group mb-3">
        <select v-model="month" class="form-control space-rgt">
          <option disabled value="">Please select month</option>
          <option value="01">January</option>
          <option value="02">Febuary</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
        &nbsp;
        <select v-model="year" class="form-control space-rgt">
          <option disabled value="">Please select year</option>
          <option value="2020">2020</option>
          <option value="2021">2021</option>
          <option value="2022">2022</option>
          <option value="2023">2023</option>
          <option value="2024">2024</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
        </select>
        &nbsp;
        <select v-model="incActivationBonus" class="form-control space-rgt">
          <option disabled value="">Include activation bonus</option>
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
        &nbsp;
        <select v-model="incDownlines" class="form-control space-rgt">
          <option disabled value="">Include downlines</option>
          <option value="no">No</option>
          <option value="yes">Yes</option>
        </select>
        &nbsp;
        <div class="input-group-append">
          <button class="btn btn-outline-secondary" type="button" @click="searchBonusReport"><font-awesome-icon icon="search" /> Search</button>
        </div>
      </div>
    </div> 
    <div v-if="message" class="col-md-12 alert alert-danger">
      {{message}}
    </div>
    

    <div class="col-md-12 hgap"></div>
    <div class="col-md-12 hgap"></div>
    
    <div v-if="successful" class="col-md-12">
      <h4><font-awesome-icon icon="table" /> Bonus Report</h4>
      <div id="bonusReportPrintArea">
        <div class="" style="list-style:none;">
          <li class="">{{ currentDate }}</li>
          <li class=""><img src="../assets/edible-logo.png" alt="Edible Herbs" class="hidden-xs"></li>
          <li class=""><u>{{ selectedDate }} &nbsp; {{ currentMonthlyBonus.firstName }} &nbsp; {{ currentMonthlyBonus.surname }} &nbsp; GENEOLOGY NETWORK ({{currentMonthlyBonus.downlinesNo}})</u></li>
          <li class="">{{ month }}</li>
        </div>
        <table class="gridview">
          <tr>
            <th>Name</th><th>Period</th><th>Nation</th><th>BusinessID</th><th>Layer</th><th>Level</th>
            <th>CurrentPPV</th><th>CurrentGPV</th><th>ACCPPV</th><th>ACCGPV</th><th>SponsorID</th><th>Total Bonus</th>
          </tr>
          <tr class="table" :class="{ active: index== currentIndex }" v-for="(monthlyMembersBonus, index) in monthlyMembersBonuses" :key="monthlyMembersBonus.id" @click="toggleClass(this,'selected')">
            <td>{{ monthlyMembersBonus.surname }},&nbsp; {{ monthlyMembersBonus.first_name }}</td><td>{{ monthlyMembersBonus.month }}/{{ monthlyMembersBonus.year }}</td><td>{{ monthlyMembersBonus.nation }}</td><td>{{ monthlyMembersBonus.network_id }}</td>
            <td>{{ monthlyMembersBonus.layer }}</td><td>{{ monthlyMembersBonus.level }}</td><td>{{ monthlyMembersBonus.current_ppv }}</td><td>{{ monthlyMembersBonus.current_gpv }}</td><td>{{ monthlyMembersBonus.acc_ppv }}</td>
            <td>{{ monthlyMembersBonus.acc_gpv }}</td><td>{{ monthlyMembersBonus.sponsor_id }}</td><td>{{ monthlyMembersBonus.bonus_to_give }}</td>
          </tr>
        </table>
      </div>
      <hr/>
      <span>
        <span v-if="successful" class="alignleft"><font-awesome-icon icon="arrow-circle-right" /> Total Bonus Earned: &nbsp; {{ currentMonthlyBonus.bonusToGive }}</span>
        <button class="m-3 btn btn-sm btn-primary alignright" @click="handleExcelExport"><font-awesome-icon icon="file-excel" /> Export to Excel</button>
        <button class="m-3 btn btn-sm btn-primary alignright" @click="printBonReport"><font-awesome-icon icon="print" /> Print</button>
      </span>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div class="col-md-12">
      
    </div>  

  </div>
</template>

<script>
import MonthlyBonusService from "../services/monthly-bonus.service";
import MonthlyMembersBonusService from "../services/monthly-members-bonus.service";

export default {
  name: "bonus-list",
  data() {
    return {
      currentMemberId: 0,
      upline: 0,
      currentMonthlyBonus: null,
      currentDate: null,
      selectedDate: null,
      selectedPeriod: null,
      month: '',
      year: '',
      incActivationBonus: '',
      incDownlines: '',
      message: '',
      successful: false,
      monthlyMembersBonuses: [],
      currentIndex: 0,
      page: 1,
      count: 0,
      pageSize: 100,
      pageSizes: [25, 50, 75, 100],
      totalPages: 0,
      loading: false,
      filename: 'bonus-report',
      autoWidth: true,
      bookType: 'xlsx'
    };
  },
  methods: {
    getCurrentDate() {
      //this.currentDate = new Date();
      let date = new Date();
      let dYear = date.getFullYear();
      let dMonth = date.getMonth() + 1;
      let dDay = date.getDate();
      this.currentDate = 'Date: '+dDay+'-'+dMonth+'-'+dYear;
    },

    getMonthlyBonus() {
      MonthlyBonusService.getMonthlyBonusByMemberIdMonthAndYear(this.upline, this.month, this.year)
        .then(response => {
          this.currentMonthlyBonus = response.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    MonthlyMembersBonus() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      MonthlyMembersBonusService.getTotalMonthlyMembersBonusByMemberIdMonthAndYear(this.upline, this.month, this.year)
        .then(response => {
          this.count = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
      MonthlyMembersBonusService.getMonthlyMembersBonusByMemberIdMonthAndYear(this.upline, this.month, this.year, this.page, this.pageSize)
        .then(response => {
          this.monthlyMembersBonuses = response.data;
          this.loading = false;
          this.message = '';
          this.successful = true;
        })
        .catch(e => {
          console.log(e);
        });
    },

    searchBonusReport() {
      this.selectedDate = this.month+'-'+this.year;
      this.selectedPeriod = this.month+'/'+this.year;
      if(this.month == '' || this.year == '' || this.incActivationBonus == '' || this.incDownlines == ''){
        this.message = 'Please, kindly select all paramenters/criteria to run bonus report!';
        //return;
      }
      else {
        //this.message = 'this.currentMemberId: '+this.currentMemberId+', this.month:'+this.month+', this.year:'+this.year;
        this.getMonthlyBonus();
        this.MonthlyMembersBonus();
      }
    },
    
    printBonReport() {
      // Pass the element id here
      this.$htmlToPaper('bonusReportPrintArea');
    },

    handlePageChange(value) {
      this.page = value;
      this.MonthlyMembersBonus();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.MonthlyMembersBonus();
    },

    handleExcelExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['Surname', 'First Name', 'Month', 'Year', 'Nation', 'Business ID', 'Layer', 'Level', 'Current PPV', 'Current GPV', 'ACCPPV', 'ACCGPV', 'Sponsor ID', 'Total Bonus']
        const filterVal = ['surname', 'first_name', 'month', 'year', 'nation', 'network_id', 'layer', 'level', 'current_ppv', 'current_gpv', 'acc_ppv', 'acc_gpv', 'sponsor_id', 'bonus_to_give']
        const list = this.monthlyMembersBonuses
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.downloadLoading = false
      })
    },

    formatJson(filterVal, jsonData) {
      //let mmbSurname = ''
      //let mmbFirstName = null
      //let mmbMonth = ''
      //let mmbYear = null
      //let count = 1
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },

    exportToExcel() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      
      MonthlyMembersBonusService.getMonthlyMembersBonusByMemberIdMonthAndYearExportToExcel(this.upline, this.month, this.year, this.page, this.pageSize)
        .then(response => {
          console.log('return data:', response);
          console.log('return excel file:', response.data);
          this.download(response);
          //window.open(response, '_blank');
          this.loading = false;
          this.message = '';
          this.successful = true;
        })
        .catch(e => {
          console.log(e);
        });
    },

    download(data) {
      if(!data){
        return;
      }
      
      var blob = new Blob([data.data], {type: 'application/vnd.ms-excel;charset=utf-8'});
      var url = window.URL.createObjectURL(blob);
      var aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.href = url;
      //aLink.setAttribute("Member Bonus", "memberbonus.xls");
      //aLink.setAttribute('memberbonus', 'memberbonus.xlsx')
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink); //Remove the element after downloading
      window.URL.revokeObjectURL(url); //Release the blob object

      /*const bloc = this.dataURLtoBlob(data);
      const blob = new Blob([bloc], {
        type: 'application/vnd.ms-excel'
      });
      const downLoadEle = document.createElement('a');
      // Create an object URL through the returned binary data.
      const href = URL.createObjectURL(blob);
      downLoadEle.href = href;
      // The information table is a custom file name
      downLoadEle.download ='Information Sheet';
      document.body.appendChild(downLoadEle);
      downLoadEle.click();
      this.loading = false;
      this.message = '';
      this.successful = true;
      document.body.removeChild(downLoadEle);
      // Release the object URL when loading is complete.
      window.URL.revokeObjectURL(href);
      // window.open(fileurl, '_blank')*/
    },
  
    /*dataURLtoBlob(dataurl) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime
      });
    },*/

    toggleClass(el, className) {
      if (el.className.indexOf(className) >= 0) {
         el.className = el.className.replace(className,"");
      }
      else {
        el.className  += className;
      }
    },

    membersList() {
      this.$router.push('/members');
    }

  },
  mounted() {
    this.message = '';
    this.upline = this.$route.params.id;
    this.currentMemberId = this.$route.params.id;
    this.getCurrentDate();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.space-rgt{
  margin-right:2em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}

.alignright{
  float: right;
}

.alignleft{
  float: left;
  font-size: large;
  font-weight: bold;
}
  
</style>